import React, { lazy, } from 'react';
const Login = lazy(() => import('../forms/Login'));

const publicRoutes = [
  { element: <Login />, path: "login" }
];

export default publicRoutes;